import { render, staticRenderFns } from "./CustomizeTags.vue?vue&type=template&id=34c36bc5&scoped=true&"
import script from "./CustomizeTags.vue?vue&type=script&lang=js&"
export * from "./CustomizeTags.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeTags.vue?vue&type=style&index=0&id=34c36bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c36bc5",
  null
  
)

export default component.exports